<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="isEdit ? $t('product-manager::prop::edit_button') : $t('product-manager::prop::add_button')"
    :visible.sync="dialogVisible"
    width="500px"
  >
    <el-form
      :model="propForm"
      :rules="rules"
      @submit.native.prevent
      class="demo-ruleForm"
      label-position="top"
      label-width="100px"
      ref="propForm"
    >
      <el-form-item class="mb-0" label label-width="0">
        <el-radio-group v-model="propForm.type" :disabled="isEdit">
          <el-radio :label="1">{{ $t('product-manager::prop::custom_prop') }}</el-radio>
          <el-radio :label="2">{{ $t('product-manager::prop::trigger_prop') }}</el-radio>
        </el-radio-group>
        <el-tooltip class="item" effect="dark" placement="top">
          <span slot="content">{{ $t('product-manager::prop::tooltip_prop') }}</span>
          <i class="icon-a-01wenhao iconfont-el"></i>
        </el-tooltip>
      </el-form-item>

      <el-form-item :label="$t('product-manager::prop::prop_name')" prop="name">
        <el-input :placeholder="$t('product-manager::prop::prop_name')" v-model.trim="propForm.name"></el-input>
      </el-form-item>
      <div style="position: relative" v-if="propForm.type === 2">
        <span style="line-height: 40px">属性值：</span>
        <template>
          <!-- <ScrollsBar > -->
          <div class="item-content">
            <el-form-item
              :key="item.key"
              :prop="'values.' + index + '.value'"
              :rules="{
                required: true,
                message: `${$t('product-manager::prop_value::placeholder_name')}`,
                trigger: 'blur',
              }"
              label
              label-width="0px"
              v-for="(item, index) in propForm.values"
            >
              <div style="display: flex">
                <el-input :placeholder="$t('product-manager::prop::table_prop')" v-model="item.value"></el-input>
                <!-- <el-button @click.prevent="removeAttrItem(item)" type="text">
                  <i class="iconfont icondelete icon-btn"></i>
                </el-button> -->
                <i class="add-btn" :class="index === 0 ? 'el-icon-plus' : 'el-icon-minus'" @click="handle(index)"></i>
              </div>
            </el-form-item>
            <!-- <el-button @click="addAttrItem" size="small">
                {{ $t('product-manager::prop_value::add_button') }}
              </el-button> -->
          </div>
          <!-- </ScrollsBar> -->
        </template>
      </div>
    </el-form>
    <div class="footer_class" slot="footer" style="text-align: center; display: block">
      <el-button @click="dialogVisible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button @click="saveSuccess" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAttrList, updateProp, deleteProp } from '@/server/product'
const validateSpace = (rule, value, callback) => {
  if (!value.trim()) {
    callback(new Error('请输入内容'))
  } else {
    callback()
  }
}
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      propForm: {
        values: [{ value: '' }],
        type: 1,
        name: '',
        id: '',
      },
      options: [],
      // pagination: {
      //   pageNum: 1, // 页码
      //   pageSize: 20, // 每页大小
      //   total: 0
      // },
      rules: {
        name: [
          { required: true, message: this.$t('product-manager::prop::placeholder_prop_name'), trigger: 'blur' },
          // { validator: validateSpace, trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    removeAttrItem(item) {
      var index = this.propForm.values.indexOf(item)
      if (index !== -1) {
        this.propForm.values.splice(index, 1)
      }
    },
    addAttrItem() {
      this.propForm.values.push({
        value: '',
      })
    },
    handle(index) {
      if (index === 0) {
        this.propForm.values.push({ value: '' })
      } else {
        this.propForm.values.splice(index, 1)
      }
    },
    show(row) {
      this.dialogVisible = true
      this.propForm = this.$deepClone(
        row || {
          type: 1,
          name: '',
          values: [{ value: '' }],
        }
      )
    },
    updatePropListData(params) {
      const _this = this
      this.$refs.propForm.validate(function (valid) {
        if (valid) {
          // params.name = params.name.trim()
          // console.log('params.name is ', params.name)
          // const {data} = await updateProp(params)
          if (params.type === 1) {
            delete params.values
          }
          updateProp(params).then(res => {
            const { data } = res
            console.log('编辑或者 新增的data is ', data)
            if (data.code === _this.$code) {
              if (_this.isEdit) {
                _this.$message({
                  type: 'success',
                  message: window.$t('system::tip::edit_success'),
                })
                _this.$emit('updateData')
                _this.dialogVisible = false
              } else {
                _this.$message({
                  type: 'success',
                  message: window.$t('system::tip::add_success'),
                })
                _this.$emit('updateData')
                _this.dialogVisible = false
              }
            }
          })
        }
      })
    },

    saveSuccess() {
      if (this.isEdit) {
        return this.updatePropListData({ ...this.propForm })
      }
      // 新增 不传id
      const { name, type, values } = this.propForm
      this.updatePropListData({ name, type, values })
    },
  },
}
</script>
<style scoped lang="scss">
/deep/.el-dialog__footer {
  text-align: center;
}
.icon-btn {
  margin-left: 8px;
}
.item-input {
  width: 300px;
}
.item-content {
  max-height: 180px;
  overflow: auto;
}
.icon-a-01wenhao {
  color: #999;
  font-size: 14px;
  margin-left: 5px;
}
.add-btn {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: #f0f0f0;
  border-radius: 5px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  margin-left: 24px;
}
.el-icon-plus {
  color: #0560fd;
}
.el-icon-minus {
  color: #ff0022;
}
</style>
